export default "__VITE_ASSET__BbpULXRu__"